import { render, staticRenderFns } from "./owner-scene-layer.vue?vue&type=template&id=33c525ce&"
import script from "./owner-scene-layer.vue?vue&type=script&lang=js&"
export * from "./owner-scene-layer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports